import { render, staticRenderFns } from "./messageLog.vue?vue&type=template&id=97a924fa&scoped=true&"
import script from "./messageLog.vue?vue&type=script&lang=js&"
export * from "./messageLog.vue?vue&type=script&lang=js&"
import style0 from "./messageLog.vue?vue&type=style&index=0&id=97a924fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a924fa",
  null
  
)

export default component.exports